<script setup>
import { ref } from 'vue';
import ReportHeader from './components/ReportHeader.vue';
import SummaryReports from './components/SummaryReports.vue';
import TeamTicketsSummaryTable from './components/TeamTicketsSummaryTable.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';

const activeTab = ref('conversations');
const summarReportsRef = ref(null);

const onDownloadClick = () => {
  summarReportsRef.value?.downloadReports();
};
</script>

<template>
  <ReportHeader
    :header-title="$t('TEAM_REPORTS.HEADER')"
    :header-description="$t('TEAM_REPORTS.DESCRIPTION')"
  >
    <V4Button
      v-if="activeTab === 'conversations'"
      :label="$t('TEAM_REPORTS.DOWNLOAD_TEAM_REPORTS')"
      icon="i-ph-download-simple"
      size="sm"
      @click="onDownloadClick"
    />
  </ReportHeader>

  <div class="flex gap-1 border-b border-n-weak mb-4">
    <button
      class="px-4 py-2 text-sm font-medium transition-colors"
      :class="
        activeTab === 'conversations'
          ? 'border-b-2 border-woot-500 text-woot-600'
          : 'text-n-slate-11 hover:text-n-slate-12'
      "
      @click="activeTab = 'conversations'"
    >
      {{ $t('TEAM_REPORTS.TABS.CONVERSATIONS') }}
    </button>
    <button
      class="px-4 py-2 text-sm font-medium transition-colors"
      :class="
        activeTab === 'tickets'
          ? 'border-b-2 border-woot-500 text-woot-600'
          : 'text-n-slate-11 hover:text-n-slate-12'
      "
      @click="activeTab = 'tickets'"
    >
      {{ $t('TEAM_REPORTS.TABS.TICKETS') }}
    </button>
  </div>

  <SummaryReports
    v-if="activeTab === 'conversations'"
    ref="summarReportsRef"
    action-key="summaryReports/fetchTeamSummaryReports"
    getter-key="teams/getTeams"
    fetch-items-key="teams/get"
    summary-key="summaryReports/getTeamSummaryReports"
    type="team"
    :show-business-hours-switch="false"
  />

  <TeamTicketsSummaryTable v-if="activeTab === 'tickets'" />
</template>
